import { render, staticRenderFns } from "./AddSliderDialog.vue?vue&type=template&id=2881cc0b&"
import script from "./AddSliderDialog.vue?vue&type=script&lang=js&"
export * from "./AddSliderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports